import { HeartStroke16 } from '@cian/ui-kit/icons';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Utility } from '../../components/Utility';
import { IApplicationState } from '../../types/redux';
import { FavoritesContainer } from '../FavoritesContainer';
import { trackFavoritesIconClick } from './tracking';

export const UtilityFavoritesContainer: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const deviceType = useDeviceType();
  const favoritesLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.favorites);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (deviceType === 'desktop') {
        event.preventDefault();
        setIsOpen(true);
      }

      trackFavoritesIconClick();
    },
    [deviceType],
  );

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  if (!favoritesLink) {
    return null;
  }

  return (
    <>
      <Utility title="Избранное" icon={HeartStroke16} href={favoritesLink} onClick={handleClick} />
      {isOpen && <FavoritesContainer onClose={handleClose} />}
    </>
  );
};
